import React from 'react';
import { ShowIf } from 'components/utils';
import {msg} from "constants/message";
import {validatable} from 'components/utils';
import {ReactTreeSelectOneElement} from 'components/tt-forms/react-tree-select';

class DropDownTreeSelectOneElement extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      dataOptions: this.props.dataOptions,
      value: this.props.value,
      propertyChildren: this.props.propertyChildren,
      propertyParent: this.props.propertyParent,
      isValid: true
    }
  }

  onChange(e) {
    let dataPush={
      target: {
        value: e
      }
    }
    this.setState({
      value: e ? e : '',
      isValid: true
    })
    this.props.onChange(dataPush);
  }

  validate() {
    if (this.state.value != 0 && !this.state.value && this.props.require) {
      this.setState({
        isValid: false
      });
      this.input.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataOptions: nextProps.dataOptions,
      value: nextProps.value,
      propertyChildren: nextProps.propertyChildren,
      propertyParent: nextProps.propertyParent,
    });
  }

  classNames() {
    if (!this.state.isValid && !this.state.value) {
      return 'rs-multiple-danger';
    } else {
      return '';
    }
  }

  unCheckSelectAllChildren() {
    this.props.unCheckSelectAllChildren();
  }

  render() {
    return (
      <div className={this.props.className + ' mb18'}>
        <ShowIf condition={this.props.label != ''}>
          <label className="ip-label" >
            { this.props.label }
            <ShowIf condition={this.props.require == true}>
              <span className="text-required">&nbsp;*</span>
            </ShowIf>
          </label>
        </ShowIf>
        <input className='hidden-input' ref={(input) => {this.input = input}}/>
        <div className={this.classNames()}>

          <ReactTreeSelectOneElement
            data={this.state.dataOptions}
            value={this.state.value}
            onChange={this.onChange.bind(this)}
            propertyChildren={this.state.propertyChildren}
            propertyParent={this.state.propertyParent}
            optionOpened={this.state.optionOpened}
            name={this.props.name}
            selectAllChildren={this.props.selectAllChildren}
          />
        </div>

        <ShowIf condition={!this.state.isValid && !this.state.value}>
          <div className="pt-form-helper-text">{msg.messageDefault}</div>
        </ShowIf>
      </div>
      );
  }
}

DropDownTreeSelectOneElement.defaultProps = {
  className: 'input-group',
  label: '',
  dataOptions: [],

  onChange: function() {
    console.log('Need to assign onChange method');
  },
  value: '',
  keyName: 'key',
  propertyChildren: '',
  propertyParent: '',
  require: false,
  name: ''
}

export default validatable(DropDownTreeSelectOneElement);



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/DropDownTreeSelectOneElement.jsx